module.exports = "/_next/static/images/motorsports-d5ce3907035f023078439c3c64bec45f.png";